import { computed, ref } from 'vue'

const STORAGE_KEY = 'portal.mall.recent'
const MAX_ITEMS = 12

function load(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : []
  } catch {
    return []
  }
}

const recentIds = ref<string[]>(load())

function persist() {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(recentIds.value))
  } catch {
    /* ignore quota errors */
  }
}

export function useRecentlyViewed() {
  const pushRecent = (id: string) => {
    if (!id) return
    recentIds.value = [id, ...recentIds.value.filter((item) => item !== id)].slice(0, MAX_ITEMS)
    persist()
  }

  const clearRecent = () => {
    recentIds.value = []
    persist()
  }

  const recentCount = computed(() => recentIds.value.length)

  return { recentIds, recentCount, pushRecent, clearRecent }
}
